import "normalize.css"; // Import before any custom CSS. Smoothes out browser differences.
import ReactDOM from "react-dom";
import "whatwg-fetch"; // required until cypress supports fetch API. https://github.com/cypress-io/cypress/issues/95
import AppContainer from "./containers/AppContainer/AppContainer";
import ScreenCloudReactApp from "./ScreenCloudReactApp";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <ScreenCloudReactApp>{(sc) => <AppContainer sc={sc} />}</ScreenCloudReactApp>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
